var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuBugers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 8H2.75C2.34 8 2 7.66 2 7.25C2 6.84 2.34 6.5 2.75 6.5H20.75C21.16 6.5 21.5 6.84 21.5 7.25C21.5 7.66 21.16 8 20.75 8Z",
    fill: "#666F89"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 13H2.75C2.34 13 2 12.66 2 12.25C2 11.84 2.34 11.5 2.75 11.5H20.75C21.16 11.5 21.5 11.84 21.5 12.25C21.5 12.66 21.16 13 20.75 13Z",
    fill: "#666F89"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 18H2.75C2.34 18 2 17.66 2 17.25C2 16.84 2.34 16.5 2.75 16.5H20.75C21.16 16.5 21.5 16.84 21.5 17.25C21.5 17.66 21.16 18 20.75 18Z",
    fill: "#666F89"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBugers);
export default __webpack_public_path__ + "static/media/menu-bugers.67828a9174beac55ba2a7c7a63151f4a.svg";
export { ForwardRef as ReactComponent };